export default __webpack_public_path__ + "static/media/insee-loader.4fbe1b4f.gif";